import { WarningCircle } from '@phosphor-icons/react';
import Button from '../../atoms/Button/Button';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

const AuthError = ({ handleClick = noop }) => {
  return (
    <div className="flex h-screen w-screen flex-col gap-4 justify-center items-center overflow-auto bg-custom-bg">
      <WarningCircle className="w-24 h-24 text-brandSecondary" weight="thin" />
      <h3 className="text-2xl">Oops! Your session has expired.</h3>
      <div className="text-base">Please click on below button to continue.</div>
      <Button onClick={handleClick}>Sign in</Button>
    </div>
  );
};

AuthError.propTypes = {
  handleClick: PropTypes.func,
};

export default AuthError;
